const TypePublicIP = {
  PUBLIC_IP: 'publicIp',
  PUBLIC_IP_V6: 'publicIpv6',
  PUBLIC_IP_V4: 'publicIpv4',
};

export default TypePublicIP;
